import type * as t from 'io-ts';
import { omitCodecKeys } from '@bayer-int/portletce-shared';

import type { SettingFormInputDefinition} from 'header/types';
import { SettingFormInputDefinitionCodec } from 'header/types';

/**
 * Users can define their own settings by providing setting definition. This type
 * is an intermediate step between user input and internal setting definition.
 * This e.g. allows us to make 'key' property optional/inferred automatically.
 */

const CustomSettingFormDefinitionInputC = omitCodecKeys(SettingFormInputDefinitionCodec, 'key');

export type CustomSettingFormDefinitionInput = t.TypeOf<typeof CustomSettingFormDefinitionInputC>;

export const CustomSettingFormDefinitionInput = {
    codec: CustomSettingFormDefinitionInputC,

    toSettingFormInputDefinition: (
        property: string,
        input: CustomSettingFormDefinitionInput,
    ): SettingFormInputDefinition => ({
        ...input,
        key: property,
    }),
};
